import { ApolloQueryResult, useQuery } from "@apollo/client";
import { RoleBaseResponse, ROLES_QUERY, RolesArgs, RolesResponseData } from "../graphql/role";

export type UseRolesReturnType = {
  refetchRolesSelect: (variables?: Partial<RolesArgs>) => Promise<ApolloQueryResult<RolesResponseData>>;
  rolesSelect?: Array<RoleBaseResponse>;
};

export const useRoles = (): UseRolesReturnType => {

  const { data: rolesSelectResponseData, refetch: refetchRolesSelect } = useQuery<RolesResponseData, RolesArgs>(ROLES_QUERY, {
    fetchPolicy: 'no-cache',
    variables: {
      includeMetadata: false,
      includeDetails: false,
    },
  });

  return {
    refetchRolesSelect,
    rolesSelect: rolesSelectResponseData?.roles,
  };
};

export default useRoles;
